import { CAMERA_ROTATION_OPTIONS, STREAM_DATA_TYPE_OPTIONS, TIMESTAMP_SOURCE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { EVENT_POLICY_TRIGGER_OPTIONS, IMAGE_FORMAT_OPTIONS, SENDING_TYPE_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';

const defaultValuesQueue = {
  name: '',
  description: {
    zone_group: null,
    zone_count_type: 'count_gte',
    zone_count_threshold: 5,
  },
  group_name: null,
  data: {
    downloadable: false,
    type: STREAM_DATA_TYPE_OPTIONS.stream,
    reference: '',
    rotation: CAMERA_ROTATION_OPTIONS[0],
    timestamp_source: TIMESTAMP_SOURCE_OPTIONS.auto,
    pts: {
      start_time: 0,
    },
  },
  location: {
    city: null,
    area: null,
    district: null,
    street: null,
    house_number: null,
    geo_position: {
      longitude: null,
      latitude: null,
    },
  },
  autorestart: {
    restart: false,
    attempt_count: 10,
    delay: 60,
  },
  analytics: [
    {
      analytic_name: 'people_count',
      parameters: {
        parameters: {
          people_count_threshold: 0,
          probe_count: 1,
          event_policy: {
            trigger: EVENT_POLICY_TRIGGER_OPTIONS.period,
            interval: 60,
          },
          image_retain_policy: {
            mimetype: IMAGE_FORMAT_OPTIONS.JPEG,
            quality: 1,
            max_size: 640,
          },
          rate: {
            unit: SENDING_TYPE_OPTIONS.second,
            period: 1,
          },
          roi: {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            mode: 'abs',
          },
          droi: {
            area: '',
            mode: 'abs',
            form: 'wkt',
          },
        },
        targets: ['coordinates', 'overview'],
        callbacks: [
          {
            type: 'luna-ws-notification',
          },
          {
            type: 'luna-event',
          },
        ],
        // FIXME: это костыль, чтобы в компоненте QueueSubForm подсвечивались поля с ошибками, надо выкинуть после рефакторинга
        description: {
          zone_group: null,
          zone_count_type: 'count_gte',
          zone_count_threshold: 5,
        },
      },
    },
  ],
};

export const defaultValues = {
  queue: defaultValuesQueue,
};
